import module from 'viaticos/module.js'

export class ViaticosViaticoDevolucionesDocumentosArchivoService {
  constructor ($http, $api) {
    this.$http = $http
    this.$api = $api
  }

  get (archivo_id) {
    return this.$http.get('/api/viaticos/viaticos/viatico/devoluciones/documentos/archivo', {
      params: {
        archivo_id: archivo_id,
      },
    })
  }

  link (archivo_id) {
    return this.$api.link('/api/viaticos/viaticos/viatico/devoluciones/documentos/archivo', {
      archivo_id: archivo_id,
    })
  }
}

module.service('ViaticosViaticoDevolucionesDocumentosArchivoService', ViaticosViaticoDevolucionesDocumentosArchivoService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Devoluciones/Documentos/Archivo.js